module.exports = __webpack_public_path__ + "static/media/t121.3af05ea7.png";